import { useRef, useState } from "react";
import { toast } from "sonner";
import { UploadCloud, FileSpreadsheet } from "lucide-react";
import api, { formatApiErrorDetail } from "../../lib/api";

export default function AdminUpload({ onUploaded }) {
  const inputRef = useRef(null);
  const [uploading, setUploading] = useState(false);
  const [fileName, setFileName] = useState("");

  const handleFile = async (file) => {
    if (!file) return;
    setFileName(file.name);
    setUploading(true);
    const form = new FormData();
    form.append("file", file);
    try {
      const { data } = await api.post("/admin/upload", form, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      toast.success(`Uploaded \u2014 ${data.records} records across ${data.periods} months`, {
        description: `Latest month: ${data.latest_period}`,
      });
      window.dispatchEvent(new Event("data-updated"));
      onUploaded?.();
    } catch (err) {
      toast.error("Upload failed", { description: formatApiErrorDetail(err.response?.data?.detail) });
    } finally {
      setUploading(false);
    }
  };

  return (
    <div className="bg-brand-surface border border-brand-border p-6" data-testid="admin-upload-panel">
      <div className="flex items-center justify-between mb-4">
        <div>
          <p className="text-xs uppercase tracking-[0.15em] text-brand-tertiary">Admin</p>
          <p className="font-serif text-xl text-brand-ink mt-1">Upload Monthly Spreadsheet</p>
        </div>
      </div>
      <div
        onClick={() => !uploading && inputRef.current?.click()}
        onDragOver={(e) => e.preventDefault()}
        onDrop={(e) => { e.preventDefault(); handleFile(e.dataTransfer.files?.[0]); }}
        data-testid="admin-upload-dropzone"
        className="border border-dashed border-brand-borderStrong bg-brand-hover hover:bg-brand-page cursor-pointer transition-colors duration-200 py-10 flex flex-col items-center justify-center text-center"
      >
        {uploading ? (
          <>
            <div className="h-8 w-8 rounded-full border-2 border-brand-border border-t-brand-primary animate-spin" />
            <p className="text-sm text-brand-muted mt-3">Processing {fileName}…</p>
          </>
        ) : (
          <>
            <UploadCloud className="h-8 w-8 text-brand-tertiary" />
            <p className="text-sm text-brand-ink mt-3">Drop your .xlsx file here, or click to browse</p>
            <p className="text-xs text-brand-tertiary mt-1 flex items-center gap-1">
              <FileSpreadsheet className="h-3.5 w-3.5" /> Replaces existing data with the latest actuals
            </p>
          </>
        )}
        <input
          ref={inputRef} type="file" accept=".xlsx,.xlsm" className="hidden"
          data-testid="admin-upload-input"
          onChange={(e) => handleFile(e.target.files?.[0])}
        />
      </div>
    </div>
  );
}
